export const selectReportData = (state) => state.companyProjectReport?.reportData || null;
export const selectReportLoading = (state) => state.companyProjectReport?.loading || false;
export const selectReportError = (state) => state.companyProjectReport?.error || null;
